import React, { useState } from 'react';
import './InteractiveMap.css';
import { useTranslation } from 'react-i18next';

// 1. Define las rutas de las imágenes en un objeto para mayor claridad y mantenimiento
const imagePaths = {
    empty: '/assets/images/map/interactive-map-empty.svg',
    airports: '/assets/images/map/interactive-map-airports.svg',
    flights: '/assets/images/map/interactive-map-flights.svg',
    full: '/assets/images/map/interactive-map-full.svg',
};

function InteractiveMap() {
    const { t } = useTranslation();
    const [airportsChecked, setAirportsChecked] = useState(false);
    const [flightsChecked, setFlightsChecked] = useState(false);

    const getImageSrc = () => {
        if (airportsChecked && flightsChecked) {
            return imagePaths.full;
        }

        if (airportsChecked) {
            return imagePaths.airports;
        }

        if (flightsChecked) {
            return imagePaths.flights;
        }

        return imagePaths.empty;
    };

    return (
        <div className="interactive-map">
            <div className="interactive-map__inner">
                <div className="interactive-map__content">
                    <h2 className="interactive-map__heading">{t('pages/home:map.title')}</h2>
                    <div className="interactive-map__description">{t('pages/home:map.description')}</div>
                    <div className="interactive-map__description">{t('pages/home:map.description2')}</div>
                </div>
                <div className="interactive-map__map">
                    <img src={getImageSrc()} className="interactive-map__image" alt="Interactive Map" />
                    <div className="interactive-map__filter-list">
                        <div className="interactive-map__filter-item">
                            <label className="interactive-map__filter-item-label">
                                <input
                                    type="checkbox"
                                    checked={airportsChecked}
                                    className="interactive-map__filter-item-checkbox"
                                    onChange={() => setAirportsChecked(prev => !prev)}
                                />
                                <span>{t('pages/home:map.toggles.airports')}</span>
                            </label>
                        </div>
                        <div className="interactive-map__filter-item">
                            <label className="interactive-map__filter-item-label">
                                <input
                                    type="checkbox"
                                    checked={flightsChecked}
                                    className="interactive-map__filter-item-checkbox"
                                    onChange={() => setFlightsChecked(prev => !prev)}
                                />
                                <span>{t('pages/home:map.toggles.flights')}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InteractiveMap;